import Splide from '@splidejs/splide';

const REVIEW_CLAMP_HEIGHT = 240;

document.querySelectorAll('.js-reviews').forEach((carousel) => {
  const slider = new Splide(carousel, {
    type: 'loop',
    arrows: true,
    pagination: true,
    perPage: 1,
    perMove: 1,
    fixedWidth: '950px',
    gap: 150,
    focus: 'center',
    speed: 600,
    autoHeight: true,
    breakpoints: {
      1366: {
        fixedWidth: '760px',
        gap: 70,
      },
      1024: {
        fixedWidth: '540px',
      },
      767: {
        fixedWidth: '320px',
        arrows: false,
      },
    },
  });

  const updateOpacity = () => {
    const Slides = slider.Components.Slides;
    const allSlides = Slides.get();
    const activeSlide = Slides.getAt(slider.index);

    allSlides.forEach((Slide) => {
      const el = Slide.slide;
      el.style.transition = 'opacity 0.5s ease';
      el.style.opacity = '0.3';
    });

    if (activeSlide) {
      const el = activeSlide.slide;
      el.style.transition = 'opacity 0.5s ease';
      el.style.opacity = '1';
    }
  };

  slider.on('mounted move', updateOpacity);
  slider.mount();

  // Clamp long reviews with an expand button
  carousel.querySelectorAll('.js-review-text').forEach((textEl) => {
    if (textEl.scrollHeight <= REVIEW_CLAMP_HEIGHT) return;

    const review = textEl.closest('.review');
    const expandBtn = review.querySelector('.js-review-expand');

    textEl.classList.add('review__text--clamped');
    expandBtn.hidden = false;

    expandBtn.addEventListener('click', () => {
      textEl.classList.remove('review__text--clamped');
      expandBtn.hidden = true;
      slider.refresh();
    });
  });
});
